const showContent = {
	el: {
		btnShowContent: document.querySelectorAll('.js-show-content')
	},

	fxShowContent(element) {
		element.parentElement.querySelectorAll('.d-none').forEach(el => el.classList.remove('d-none'))
		element.style.opacity = '0'
	},

	events() {
		this.el.btnShowContent.forEach(el => el.addEventListener('click', e => this.fxShowContent(e.currentTarget)))
	},

	init() {
		this.events()
	}
}

showContent.init()